import lazyLoadView from '@utils/lazy-load-view';
import roles from '@constants/roles';
export default {
	// prefix: 'somepath/',
	childof: 'inicio-view',
	routes: [
		{
			path: 'bancosDePreguntas',
			name: 'bancosDePreguntas',
			title: 'Bancos de preguntas',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(import('@views/bancosDePreguntas/bancosDePreguntas.vue'))
		},
		{
			path: 'bancosDePreguntas/detalle/:clave',
			name: 'detalleBancoDePreguntas',
			title: 'Detalle de banco de preguntas',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(import('@views/bancosDePreguntas/detalle/detalle.vue'))
		}
	]
};
